import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HasPermissionDirective } from '../has-permission.directive';
import { ResizableDirective } from '../resizable.directive';
import { RequestImageDirective } from '../request-image.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    HasPermissionDirective,
    ResizableDirective,
    RequestImageDirective
  ],
  exports: [
    HasPermissionDirective,
    ResizableDirective,
    RequestImageDirective
  ]
})
export class DirectivesModule { }
